import { Container, ContainerProps } from '@mantine/core';

/**
 * Page component
 * @public
 *
 * @param size - The size of the page
 * @param w - The width of the page
 * @param sx - The style object
 * @param children - The children to render
 * @param containerProps - Container props
 */
export const Page: React.FC<ContainerProps> = ({
  size = 'md',
  w = '100%',
  sx,
  children,
  ...containerProps
}) => (
  <Container
    bg="white"
    sx={{
      maxHeight: '100%',
      position: 'relative',
      zIndex: 1,
      paddingLeft: 36,
      paddingRight: 36,
      ...sx,
    }}
    w={w}
    size={size}
    {...containerProps}
  >
    {children}
  </Container>
);
